module.exports = __webpack_public_path__ + "static/img/2.23b7835.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/3/1/zh/2.png
// module id = cW9w
// module chunks = 0